import { type FC, Suspense } from 'react';
import { Island, VStack } from '@direct-frontend/components';
import { PageStub } from '#shared/components/PageStub';
import { DashboardTodoList } from './DashboardTodoList';
import { DashboardTodoListFeatureHintsPendingRegistration } from './DashboardTodoListFeatureHintsPendingRegistration';

export const DashboardTodoListSuspense: FC = () => (
    <Suspense
        fallback={
            <>
                <DashboardTodoListFeatureHintsPendingRegistration />
                <Island paddingCorrection="top-bottom">
                    <VStack gap="28">
                        <PageStub />
                    </VStack>
                </Island>
            </>
        }
    >
        <DashboardTodoList />
    </Suspense>
);
